import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

interface PageSectionProps {
  title: string;
  blurb?: string;
  colour: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

function PageSection({ title, blurb, colour, icon, children }: PageSectionProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 3,
        overflow: 'hidden',
        bgcolor: 'background.paper',
        mb: 2.5,
      }}
    >
      {title && (
        <Box
          sx={{
            px: { xs: 2, md: 2.5 },
            pt: { xs: 2, md: 2.5 },
            pb: 2,
            borderBottom: 1,
            borderColor: 'divider',
            bgcolor: 'grey.50',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 46,
                height: 46,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: `${colour}26`,
                color: colour,
                border: 1,
                borderColor: `${colour}55`,
                flexShrink: 0,
                '& svg': {
                  fontSize: 28,
                },
              }}
            >
              {icon}
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: 900,
                  lineHeight: 1.2,
                }}
              >
                {title}
              </Typography>

              {blurb && (
                <Typography
                  variant="body1"
                  component="p"
                  color="text.secondary"
                  sx={{
                    mt: 0.75,
                    fontWeight: 700,
                  }}
                >
                  {blurb}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      )}

      <Box sx={{ p: { xs: 2, md: 2.5 } }}>{children}</Box>
    </Paper>
  );
}

export default PageSection;
